module.exports = __webpack_public_path__ + "img/order_time.ecbc6223.png";